import { Alert } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const TryAgainLater = ({ tryAgainError }) => {
    const { t } = useTranslation();
    const retryDate = tryAgainError === null || tryAgainError === void 0 ? void 0 : tryAgainError.match(/(\d{4})-(\d{2})-(\d{2})/);
    const dateFormatted = retryDate === null || retryDate === void 0 ? void 0 : retryDate.slice(1).join('-');
    if (!dateFormatted) {
        return null;
    }
    return (<Alert title={t('financing.try_again_later.title')} variant="info">
            <div className="body-m">
                {t('financing.try_again_later.message')} {dateFormatted}
            </div>
        </Alert>);
};
export default TryAgainLater;
